import React from 'react';
import { withRouter } from 'react-router-dom'
import Docs from '../components/docs'

class DocsPage extends React.Component{

    render(){

        const { activeTab, docId } = this.props.match.params

        return(
            <Docs
                activeTab={activeTab}
                docId={docId}
            />
        )
    }
}

export default withRouter(DocsPage);


// WEBPACK FOOTER //
// ./src/containers/docs-page.js